import { useSyncExternalStore } from "react";

// ONE list of access buttons: built by the desktop nav (PwhlSectionsBar), read by the mobile Access sheet.
let state = { list: [] };
const subs = new Set();
export const publishAccess = (list) => { state = { list }; subs.forEach((f) => f()); };
export const useAccessList = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state).list;
